/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
export const CanvasAreaType = core.serialization.enum_([
    "mapping",
    "header",
    "agent",
    "form",
    "sheet",
    "sheets",
    "workbook",
    "document",
    "file",
    "iframe",
]);
